import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    refreshUrl: String,
    interval: { type: Number, default: 2000 }
  }

  static targets = ["bar", "label", "detail", "sentCount", "failedCount", "skippedCount"]

  connect () {
    if (!this.hasUrlValue) return
    this.tick()
  }

  disconnect () {
    if (this.timeoutId) clearTimeout(this.timeoutId)
  }

  async tick () {
    try {
      const res = await fetch(this.urlValue, {
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }
      })
      if (!res.ok) {
        this.scheduleNext()
        return
      }

      const data = await res.json()
      this.renderProgress(data)

      if (data.done) {
        window.location.assign(this.refreshUrlValue || window.location.pathname)
        return
      }
    } catch (_e) {
      // network error: retry
    }
    this.scheduleNext()
  }

  scheduleNext () {
    this.timeoutId = setTimeout(() => this.tick(), this.intervalValue)
  }

  renderProgress (data) {
    if (this.hasBarTarget) {
      this.barTarget.style.width = `${data.percent}%`
      if (data.indeterminate) {
        this.barTarget.classList.add("animate-pulse")
      } else {
        this.barTarget.classList.remove("animate-pulse")
      }
    }

    if (this.hasLabelTarget && data.label) {
      this.labelTarget.textContent = data.label
    }

    if (this.hasDetailTarget) {
      if (data.detail) {
        this.detailTarget.textContent = data.detail
        this.detailTarget.classList.remove("hidden")
      } else {
        this.detailTarget.classList.add("hidden")
      }
    }

    if (this.hasSentCountTarget && data.sent != null) {
      this.sentCountTarget.textContent = data.sent
    }
    if (this.hasFailedCountTarget && data.failed != null) {
      this.failedCountTarget.textContent = data.failed
    }
    if (this.hasSkippedCountTarget && data.skipped != null) {
      this.skippedCountTarget.textContent = data.skipped
    }
  }
}
